import Layout from "../../../components/layout";
import MainContent from "../../../components/maincontent";
import React from "react";
import Schedule from "../../../components/schedule/2020/schedule";
import Seo from "../../../components/seo";
import BackButtonInSchedules from "../../../components/navigation/backbuttoninschedules";

const IndexPage = () => (
  <Layout>
    <Seo
      title="Camp 2020 - Schedule"
      description="Schedule for Charity Grace Bible Camp 2020"
      lang="en"
      meta={[
        {
          content: "God, Jesus, Gospel, Heaven, Salvation, Saved, Grace, Free, How, Mid-Acts, Romans, Charity Grace Bible Church, Illinois",
          name: "keywords"
        }
      ]}
    />

    <MainContent
      hasArticle={false}
      hasBanner={false}
    >
      <BackButtonInSchedules  />
      
      <div className="grid--4 grid-padding align--center"  >
        <h2>Camp Schedule 2020</h2>
        <span className="caption">October 8th - October 11th</span>
      </div>

      <div className="grid--4 grid-padding align--center"  >
        <a
          href="/assets/pdf/CGBC_2020_Schedule.pdf"
          className="button button--green"
          download=""
        >
          <i className="fa fa-file-pdf-o" aria-hidden="true" /> Download PDF
        </a>
      </div>
    </MainContent>
    <Schedule />
  </Layout>
);

export default IndexPage;
